<template>
  <div class="wrapper">
    <!--头部-->
    <page-head
      title="社工"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    >
    </page-head>
    <Modal v-model="isAddWorker" title="社工加入" width="580px" footer-hide>
      <div class="code-content">
        <div class="code-img"><img :src="qrCodeUrl" alt="" /></div>
        <div
          class="code-text"
          :data-url="qrCodeUrl"
          data-type="小程序"
          @click="downCode"
        >
          下载二维码
        </div>
      </div>
    </Modal>
    <Modal
      v-model="isShowDelete"
      title="删除"
      width="660px"
      @on-ok="onDelete"
      @on-cancel="onCancel"
    >
      <div>确定删除该社工吗？</div>
    </Modal>
    <delete-people
      v-if="isShowSelect"
      :modal="isShowSelect"
      :message="message"
      :api="urlobj.workList()"
      :params="ruleSelect"
      :deleteUnionid="deleteUnionid"
      @onDelete="turnToOther"
      @onCancel="onCancel"
      title="删除社工"
    >
    </delete-people>
    <!-- <Modal v-model="isDelAll" title="删除" width="660px" @on-ok="delAll" @on-cancel="cancelDel">
      <div>确定删除这些社工吗？</div>
    </Modal> -->
    <Modal v-model="isShowMove" title="移动至" width="580">
      <div class="add-wrapper">
        <div class="add-item">
          <label class="add-label">移动至</label>
          <RadioGroup v-model="addTo" size="large" @on-change="radioChange">
            <Radio label="微支部"></Radio>
            <Radio label="微社区"></Radio>
          </RadioGroup>
        </div>
        <div class="add-item">
          <label class="add-label">请选择</label>
          <Select
            v-model="checkList"
            style="width:500px"
            @on-change="selChange"
          >
            <Option v-for="item in selList" :value="item.id" :key="item.id">{{
              item.label
            }}</Option>
          </Select>
        </div>
      </div>
      <div slot="footer">
        <Button class="add-confirm" @click="clearModel">取消</Button>
        <Button class="add-confirm" type="warning" @click="sendEditScore"
          >确认</Button
        >
      </div>
    </Modal>
    <sqfw-card
      :userList="userList"
      @cardClick="toDetail"
      @delPeople="delPeople"
      v-on:checkList="getCheckList"
      :checkList="checkList"
    ></sqfw-card>
    <div class="fenye box">
      <div class="clickAll box">
        <i
          class="iconfont icon-clickall"
          :class="[clickAll ? 'icon-duoxuan1' : 'icon-duoxuankuang1']"
          @click="checkAll"
        ></i>
        全选(当前页)
      </div>
      <Page
        :total="total"
        class="page box_f1"
        :current="pageNum"
        @on-change="handleChangePage"
        show-total
      />
      <div class="clickTotal box">
        已选
        <span style="font-size:18px;color: #fe7d43">{{
          checkList.length
        }}</span>
      </div>
      <div class="clickBtn box">
        <Button type="success" @click="shAll" :disabled="btnDisabled"
          >审核通过</Button
        >
        <!-- <Button type="warning" @click="showMove" :disabled="btnDisabled">移动至</Button> -->
        <!-- <Button type="error" @click="showDelAll" :disabled="btnDisabled">删除</Button> -->
      </div>
    </div>

    <!-- modal 添加社工 -->
    <Modal
      v-model="addWorkerModal"
      title="添加社工"
      :mask-closable="false"
      width="660"
      @on-ok="addWorker"
      class-name="vertical-center-modal"
    >
      <!--@on-change="handleClick"-->
      <div class="tr box">
        <div class="tr_title">工作单位</div>
        <Select
          v-model="workPlace"
          style="width:560px"
          placeholder="请选择工作单位"
          size="large"
        >
          <Option
            v-for="(item, index) in workPosition"
            :value="item.id"
            :key="index"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
      <div class="tr box">
        <div class="tr_title" style="padding-top:15px">人员</div>
        <Input
          v-model="modalSearchName"
          size="large"
          placeholder="请输入微信昵称/真实姓名"
          style="width: 560px;padding-top:15px;"
          enter-button="搜索"
          search
          @on-search="inputSearch({ refresh: true })"
        />
      </div>
      <div class="searchcard-wrapper" @scroll="thr_onSearchScroll">
        <div v-if="workSearching && !workList.length" class="nodata red">
          搜索不到该用户。请输入正确的微信昵称或真实姓名，并保证该用户已使用过本社区的{{promptMsg}}
        </div>
        <div
          v-else
          class="search-card"
          v-for="item in workList"
          v-bind:class="{ select: item.isSelect }"
          :key="item.unionId"
          @click="selectAdmin(item)"
        >
          <img
            v-if="item.isSelect"
            class="xuanzhong-icon color"
            src="../../assets/images/select.png"
          />
          <div class="avatar-wrap">
            <img class="avatar" v-if="item.headPicUrl" :src="item.headPicUrl" />
            <img class="avatar" v-else src="../../assets/images/default.png" />
          </div>
          <div class="search-name">
            {{ item.userName ? item.userName : "暂未绑定微信" }}
          </div>
          <div class="search-username">
            {{ item.realName ? item.realName : "暂无姓名" }}
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import pageHead from "../../components/head";
import sqfwCard from "./components/sqfwCard";
import deletePeople from "./components/deletePeople";
var that;
export default {
  data() {
    return {
      btnList: [
        // {
        //   name: "扫码加入",
        //   type: "scan",
        //   loading: false
        // },
        {
          name: "社工加入",
          type: "worker",
          loading: false
        }
      ],
      deleteUnionid: "",
      deleteCommunityid: "",
      isShowDelete: false,
      isShowSelect: false,
      pageNum: 1, // 分页1
      pageSize: 10, //  分页尺寸
      userList: [], // 用户列表
      rule: {
        realNameStatus: "",
        labelParam: {},
        residentName: "",
        communityIdList: this.$store.state.isJiedao
          ? []
          : [this.$store.state.streetorcommunityid]
      }, // 过滤器筛选类型
      ruleSelect: {}, //过滤筛选
      filterList: [],
      total: 2,
      clickAll: false,
      isDelAll: false,
      isShowMove: false,
      addTo: "微支部",
      btnDisabled: true,
      partyList: [],
      zoneList: [],
      selList: [],
      selVal: "",
      unionId: "",
      checkList: [],
      isAddWorker: false,
      qrCodeUrl: "",
      addWorkerModal: false,

      workPosition: [], // 工作单位列表
      modalSearchName: "", // 要搜索的人名
      workSearching:false, // 是否搜索已经搜索了一次，控制样式和滚动加载接口
      workPlace: "", // 工作单位
      workList: [], // 可添加为社工的人员列表
      workPageNum: 1, // 搜索人员分页
      workPageSize: 10,
      workListFinish: false, // 加载完毕
      workSelectedOne: null // 搜索人员列表里被选中的那个
    };
  },
  created() {
    console.log("[sys] userSocialWorker created");
    console.log(this.$store.state.apptype);
    that = this;
    this.reset = this._.debounce(this._reset, 100); // filter 重置时会触发函数

    this.thr_onSearchScroll = this._.throttle(this.onSearchScroll, 400);
  },
  watch: {
    /* 当前total发生变化时 右侧label显示跟着变化 */
    total(newVal) {
      this.$store.commit("updateLabelList", [
        {
          name: "filter_label",
          data: {
            label: "当前总人数",
            value: newVal
          }
        }
      ]);
    }
  },
  mounted() {
    this.getfilter(1);
    this.getWorker();
    // if(!parseInt(this.$store.state.isJiedao)){
    //   this.getWorker();
    // }
    this.getQrcode(this.$store.state.streetorcommunityid);
  },
  computed: {
    promptMsg: function () {
      return this.$store.state.apptype == 'ctt'?'丛台通或丛台先锋小程序':'民生通或先锋e家或社区云助手小程序'
    }
  },
  destroyed() {
    console.log("[sys] userSocialWorker destroyed");
    this.$store.commit("updateFilterList", []);
    this.$store.commit("updateLabelList", []);
  },
  methods: {
    handleBtn(type) {
      if (type == "scan") {
        this.showAddWorker();
      } else {
        this.addWorkerModal = true;
        this.initWorkModal() // 重置modal参数
        // 没有数据时加载一次
        if (!this.workPosition.length) this.getOrgList();
      }
    },
    // 初始化添加社工的modal
    initWorkModal(){
      this.workSearching = false
      this.modalSearchName = ""
      this.workPlace = ""
      this.workPageNum = 1
      this.workListFinish = false
      this.workSelectedOne = null
      this.workList = []
    },
    toDetail(e) {
      this.$router.push({
        name: "workerDetail",
        params: {
          unionId: e.unionId,
          communityId: e.communityId
        }
      });
    },
    getCheckList(checkList) {
      this.checkList = checkList;
      // console.log(this.filterList)
      let len1 = this.checkList.length;
      let len2 = this.userList.length;
      console.log(len1 == 0);
      this.btnDisabled = len1 == 0;
      if (len1 == len2) {
        this.clickAll = true;
      } else {
        this.clickAll = false;
      }
    },
    checkAll() {
      this.clickAll = !this.clickAll;
      if (this.clickAll == true) {
        this.checkList = [];
        this.userList.forEach(item => {
          item.clickCheck = true;
          this.checkList.push(item);
        });
        this.btnDisabled = false;
      } else {
        this.userList.forEach(item => {
          item.clickCheck = false;
        });
        this.btnDisabled = true;
        this.checkList = [];
      }
      console.log(this.checkList);
    },
    showAddWorker() {
      var idlist = this.rule.communityIdList;
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      this.isAddWorker = true;
    },
    /**批量审核 */
    shAll() {
      var idlist = this.rule.communityIdList;
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      let unionId = this.checkList.map(item => {
        return item.unionId;
      });
      let url = this.urlobj.shenheAll("worker");
      let communityId = "";
      if (this.$store.state.isJiedao == 1) {
        communityId =
          this.rule.communityIdList == []
            ? this.$store.state.streetorcommunityid
            : this.rule.communityIdList.join(",");
      } else {
        communityId = this.$store.state.streetorcommunityid;
      }
      this.$post(url, {
        unionIds: unionId.join(","),
        status: 1,
        communityId
      }).then(res => {
        this.$Message.success(res.message);
        this.checkList = [];
        this.userList.forEach(item => {
          item.clickCheck = false;
        });
        this.clickAll = false;
        this.checkList = [];
        this.btnDisabled = true;
        this.pageNum = 1;
        this._reset();
        this.getWorker();
      });
    },
    /**批量删除 */
    showDelAll() {
      var idlist = this.rule.communityIdList;
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      this.isDelAll = true;
    },
    delAll() {
      let unionId = this.checkList.map(item => {
        return item.unionId;
      });
      let url = this.urlobj.delAll;
      let communityId = "";
      if (this.$store.state.isJiedao == 1) {
        communityId =
          this.rule.communityIdList == []
            ? this.$store.state.streetorcommunityid
            : this.rule.communityIdList.join(",");
      } else {
        communityId = this.$store.state.streetorcommunityid;
      }
      this.$delete(url, {
        unionId: unionId.join(","),
        userType: "worker",
        communityId
      }).then(res => {
        this.isDelAll = false;
        this.checkList = [];
        this.btnDisabled = true;
        this.$Message.success(res.message);
        this.clickAll = false;
        this.pageNum = 1;
        this._reset();
        this.getfilter();
      });
    },
    cancelDel() {
      this.isDelAll = false;
    },
    /**批量移动 */
    showMove() {
      this.partyList = this.filterList[3].data.dataList;
      this.zoneList = this.filterList[4].data.dataList;
      this.selList = this.partyList;
      let unionId = this.checkList.map(item => {
        return item.unionId;
      });
      this.unionId = unionId.join(",");
      console.log(this.partyList, this.zoneList);
      this.isShowMove = true;
    },
    radioChange() {
      switch (this.addTo) {
        case "微支部":
          this.selList = this.partyList;
          break;
        case "微社区":
          this.selList = this.zoneList;
      }
    },
    selChange(value) {
      this.selVal = value;
    },
    clearModel() {
      this.isShowMove = false;
      this.selVal = "";
    },
    sendEditScore() {
      let data = {};
      switch (this.addTo) {
        case "微支部":
          data = {
            labelParam: { party: this.selVal }
          };
          break;
        case "微社区":
          data = {
            labelParam: { zone: this.selVal }
          };
      }
      data.unionId = this.unionId;
      let url = this.urlobj.sortToLabel();
      this.$post(url, data).then(res => {
        this.selVal = "";
        this.$Message.success(res.message);
        // this.clickAll = false
        this.checkList = [];
        this.btnDisabled = true;
        this._reset();
        this.getfilter();
        this.isShowMove = false;
      });
    },
    downCode: function(e) {
      window.open(
        this.urlobj.downloadAttachment +
          `?picPath=${e.target.dataset.url}&picName='社区云助手'-${
            e.target.dataset.type
          }二维码&token=${sessionStorage.getItem("token")}`
      );
    },
    //获取小程序码
    getQrcode(communityId) {
      // console.log(this.userList[0].communityId)
      let url = this.urlobj.getQrCode(communityId, "sqyzs");
      this.$get(url).then(res => {
        this.qrCodeUrl = res.newPrimaryKeys.qrcodeUrl;
      });
    },
    _reset() {
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空
      this.rule = {
        realNameStatus: "",
        labelParam: {},
        residentName: "",
        communityIdList: this.$store.state.isJiedao
          ? []
          : [this.$store.state.streetorcommunityid]
      };
      this.getfilter(1);
      this.getWorker();
    },
    _getTime() {
      return new Date().getTime();
    },
    /* 获取右侧筛选分类 */
    getfilter(isFirst) {
      this.$store.commit("updateSpinShow", true);
      let url = this.urlobj.worker();
      this.$get(url, {
        labelParentType: "organization",
        communityId: this.rule.communityId
      })
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            let filterData = res.rows;
            this.filterList = []; // 置空
            /* 初始化分类对象 */
            filterData = filterData.filter(item => {
              return item.type != "category" && item.type != "organization";
            });
            if (this.$store.state.isJiedao == 1) {
              filterData = filterData.filter(item => {
                return item.type != "organization";
              });
              var _url = this.urlobj.getDivision("worker");
              this.$get(_url).then(res => {
                var num = 0;
                var ids = [];
                var counts = [];
                ids = res.rows.map(item => {
                  return item.communityId;
                });
                counts = res.rows.map(item => {
                  return item.count;
                });
                counts.forEach(item => {
                  num += item;
                });
                var item1 = {
                  name: "全部",
                  id: ids.join(","),
                  userCount: num
                };
                var list = res.rows.map(item => {
                  return {
                    name: item.communityName,
                    id: item.communityId,
                    userCount: item.count
                  };
                });
                list.unshift(item1);

                if (isFirst == 1 && this.$store.state.isJiedao) {
                  //首次进来的
                  this.rule.communityIdList = ids;
                  //this.getWorker();
                }

                //匹配默认选中index
                var index1 = -1;
                list.forEach((item, index) => {
                  if (item.id == this.rule.communityIdList) {
                    index1 = index;
                  }
                });
                console.log(list);
                filterData.unshift({
                  type: "community",
                  name: "行政区域",
                  selectedIndex: index1,
                  children: list
                });
                for (const obj in filterData) {
                  this.filterList.push(new FilterItem(filterData[obj]));
                }
                this.initFilterList(this.filterList);
              });
            } else {
              for (const obj in filterData) {
                filterData[obj].that = this;
                this.filterList.push(new FilterItem(filterData[obj]));
              }
              this.initFilterList(this.filterList);
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    /* 获取社工列表 */
    getWorker() {
      let url = this.urlobj.workList();
      this.$store.commit("updateSpinShow", true);
      this.$post(url, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.rule
      })
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          this.total = res.total;
          /* zonetype 0--社区，1--小区，2--微支部 */
          /* realNameStatus 0--待审核，1--未实名，2--已实名 */
          if (res.isSucceed) {
            /* 如果有数据 */
            if (res.rows.length) {
              /* 初始化数据 */
              var resList = res.rows.map((item, index) => {
                return {
                  communityId: item.communityId,
                  showCha: false,
                  headPicUrl: item.headPicUrl,
                  name: item.workerName, // 昵称
                  unionId: item.unionId,
                  realName: item.realName,
                  authState: item.realNameStatus,
                  companyOrCommunityName: item.companyOrCommunityName,
                  clickCheck: false
                };
              });
              this.userList = resList;
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
      // 分页加1
    },
    handleChangePage(val) {
      console.log(`第${val}页`);
      this.clickAll = false;
      this.checkList = [];
      this.btnDisabled = true;
      this.pageNum = val;
      this.getWorker();
    },
    delPeople(query) {
      this.isShowDelete = true;
      this.deleteUnionid = query.unionId;
      this.deleteCommunityid = query.communityId;
      /**修改删除人有待办时查询可转派人的参数 */
      this.ruleSelect = {
        communityIdList: [query.communityId],
        labelParam: {},
        realNameStatus: 1
      };
    },
    onDelete() {
      var url = this.urlobj.delAll;

      this.$delete(url, {
        unionId: this.deleteUnionid,
        userType: "worker",
        communityId: this.deleteCommunityid
      })
        .then(res => {
          this.isShowDelete = false;
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            //删除用户
            this.pageNum = 1; //  初始化分页
            this.userList = []; // 用户数据置空
            this.checkList = [];
            this.clickAll = false;
            this.btnDisabled = true;
            this.getWorker();
            this.getfilter();
          }
        })
        .catch(e => {
          this.isShowDelete = false;
          if (e.data.code == 999901) {
            this.isShowSelect = true;
            this.message = e.data.message;
          }
          //this.$Message.error("删除失败");
        });
    },
    turnToOther(turn_unionId) {
      // let unionId = this.checkList.map(item => {
      //   return item.unionId
      // })
      let url = this.urlobj.delAll;
      let communityId = "";
      if (this.$store.state.isJiedao == 1) {
        communityId =
          this.rule.communityIdList == []
            ? this.$store.state.streetorcommunityid
            : this.rule.communityIdList.join(",");
      } else {
        communityId = this.$store.state.streetorcommunityid;
      }

      this.$delete(url, {
        unionId: this.deleteUnionid,
        userType: "worker",
        communityId,
        turn2UnionId: turn_unionId
      }).then(res => {
        this.isShowSelect = false;
        this.isDelAll = false;
        this.checkList = [];
        this.btnDisabled = true;
        this.$Message.success(res.message);
        this.clickAll = false;
        this.pageNum = 1;
        this.getWorker();
        // this._reset()
        // this.getfilter()
      });
    },
    onCancel() {
      this.isShowDelete = false;
      this.isShowSelect = false;
    },
    initFilterList(list) {
      /* search 数据 */
      let search = {
        name: "search",
        data: {},
        event: function(e) {
          that[e.fn](e);
        }
      };
      /* 认证状态对象 */
      let authState = {
        name: "authstate",
        data: {
          title: "实名状态",
          stateList: [
            {
              value: "已实名",
              stateCode: 1,
              stateColor: "#47ba54",
              active: false
            },
            {
              value: "待审核",
              stateCode: -1,
              stateColor: "#ff7744",
              active: false
            },
            {
              value: "未认证",
              stateCode: 0,
              stateColor: "#a1afb3",
              active: false
            }
          ]
        },
        event: function(e) {
          that[e.fn](e);
        }
      };
      list.unshift(search, authState);
      this.$store.commit("updateFilterList", list);
    },
    /* ---------------------所有 筛选 业务处理 代码 如下--------------------*/

    /* ==================== 搜索  BEGIN==================== */
    search({ params }) {
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空
      this.rule.residentName = params.searchValue;
      this.checkList = [];
      this.clickAll = false;
      this.btnDisabled = true;
      this.getWorker();
    },
    /* ==================== 搜索  END==================== */
    /* ==================== 认证状态  BEGIN==================== */
    authchange({ params }) {
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空
      this.rule.realNameStatus = params.stateCode; // 筛选条件更新
      this.checkList = [];
      this.clickAll = false;
      this.btnDisabled = true;
      this.getWorker();
    },
    /* ==================== 认证状态  END==================== */
    /* ==================== 分类  BEGIN==================== */
    /* 分类模块添加分类 */
    addSort({ params }) {
      let url = this.urlobj.addLabel();
      let data = {
        labelType: 2, // 社工 是2
        name: params.addValue
      };
      this.$store.commit("updateSpinShow", true);
      this.$post(url, data)
        .then(res => {
          if (res.isSucceed) {
            this.$Message.success("添加成功");
            this.getfilter();
          }
        })
        .catch(e => console.log(e));
    },
    /* 删除模块删除分类 */
    delSort({ params }) {
      let target = this.filterList[params.filterListIndex];
      let delId = target.data.dataList[params.delIndex].id;
      let url = this.urlobj.delLabel(delId);
      this.$store.commit("updateSpinShow", true);
      this.$delete(url)
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            target.data.dataList.splice(params.delIndex, 1);
          }
        })
        .catch(e => console.log(e));
    },
    /* 拖曳到分类 */
    sortDrop({ params }) {
      this._drop(params);
    },
    /* 勾选筛选选项 */
    sortChange({ params }) {
      this._groupChange(params);
    },
    /* ==================== 分类  END==================== */
    /* ==================== 行政区域  BEGIN==================== */
    areaChange({ params }) {
      console.log("行政区域筛选");
      this._groupChange(params);
    },
    /* ==================== 分类  END==================== */
    /* ==================== 微支部  BEGIN==================== */
    orgChange({ params }) {
      this._groupChange(params);
    },
    orgDrop({ params }) {
      // this._drop(params);
    },
    /* ==================== 微支部  END==================== */
    /* ==================== 小区  BEGIN==================== */
    comDrop({ params }) {
      // this._drop(params);
    },
    comChange({ params }) {
      this._groupChange(params);
    },
    /* ==================== 小区  END==================== */
    /* ==================== 来源  BEGIN==================== */
    oriChange({ params }) {
      this._groupChange(params);
    },
    oriDrop({ params }) {
      // this._drop(params);
    },
    /* ==================== 来源  END==================== */
    /******************* 公用方法 ************************/
    /* 勾选筛选 初始化不同的属性*/
    _groupChange(e) {
      let target = this.filterList[e.filterListIndex];
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空

      /* 修改筛选条件 source 传type 其他的传id*/
      if (target.type == "source") {
        this.rule.labelParam[target.type] = e.selectedIndex.map(item => {
          return target.data.dataList[item].type;
        });
      } else if (target.type == "community") {
        var val1 = target.data.dataList[e.selectedIndex].id;
        var index = String(val1).indexOf(",");
        var idlist = index == -1 ? [val1] : val1.split(",");
        this.rule.communityIdList = idlist;
      } else {
        this.rule.labelParam[target.type] = e.selectedIndex.map(item => {
          return target.data.dataList[item].id;
        });
      }
      this.getWorker();
      if (this.rule.communityIdList.length == 1) {
        this.getQrcode(this.rule.communityIdList.join(","));
      }
      this.checkList = [];
      this.btnDisabled = true;
      this.clickAll = false;
    },
    /* 拖曳放开
    2018年12月20日 暂时关闭
    */
    _drop(e) {
      let target = this.filterList[e.filterListIndex];
      let url = this.urlobj.sortToWorkerLabel();
      let data = {
        id: target.data.dataList[e.elIndex].id,
        unionId: e.dropValue
      };
      this.$store.commit("updateSpinShow", true);
      this.$post(url, data)
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            this.$Message.success("添加成功");
            this.filterList[e.filterListIndex].data.dataList[e.elIndex]
              .number++;
          }
        })
        .catch(e => {
          this.$store.commit("updateSpinShow", false);
          console.log(e);
        });
    },
    /* 获取社区企业选择列表 */
    getOrgList() {
      let url = this.urlobj.belongList();
      this.$get(url, {
        isContainsCompany: 1, // 包含 企业列表,
        communityId: this.communityId
      })
        .then(res => {
          if (res.isSucceed && res.rows.length > 0) {
            // 社区企业的选择列表
            this.workPosition = res.rows.map(item => {
              return {
                id: item.companyId,
                name: item.name
              };
            });
          }
        })
        .catch(e => console.log(e));
    },
    // 添加社工
    addWorker() {
      // 判断选中的企业
      if(!this.workPlace) return this.$Message.warning('未选择工作单位')
      if(!this.workSelectedOne) return this.$Message.warning('未选择要添加人员')

      let url = this.urlobj.workerCheck()
      let data = {
        communityId:this.$store.state.streetorcommunityid,
        companyId: this.workPlace,
        unionId: this.workSelectedOne.unionId
      }
      this.$showLoading()
      this.$post(url,data).then(res=>{
        if(!res.isSucceed) return this.$Message.error(res.message)
        this.$Message.success('添加成功')

        // 关闭弹窗
        this.addWorkerModal = false
        // 更新人员列表
        this.getWorker()

      }).finally(this.$hideLoading)
    },
    // 搜索可添加为社工的人员
    inputSearch({ refresh = false } = {}) {
      this.workSearching = true // 搜索了一次
      if (refresh) {
        this.workPageNum = 1;
        this.workList.length = 0;
      }

      let url = this.urlobj.workerList4add;
      let data = {
        pageNum: this.workPageNum,
        pageSize: this.workPageSize,
        userName: this.modalSearchName,
        communityId: this.$store.state.streetorcommunityid
      };

      this.$get(url, data).then(res => {
        if (!res.isSucceed) return this.$Message.error(res.message);
        let list = res.rows.map(item => ({
          headPicUrl: item.headPicUrl,
          realName: item.realName,
          unionId: item.unionId,
          userName: item.userName,
          isSelect: false // 全部未选中
        }));

        this.workList.push(...list);

        this.workListFinish = list.length < this.workPageSize;
      });
    },
    // 切换选择搜索的人员
    selectAdmin(cur) {
      for (let item of this.workList) {
        item.isSelect = false;
      }
      cur.isSelect = true;

      this.workSelectedOne = cur;
    },
    // 搜索区域滚动
    onSearchScroll(e) {
      // 已经加载完 返回
      if (this.workListFinish) return;
      // 不是 搜索后滚动触发 返回
      if(!this.workSearching) return
      // 触底
      let { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.workPageNum++;
        this.inputSearch();
      }
    }
  },
  components: {
    sqfwCard,
    deletePeople,
    pageHead
  }
};

/* ---------------------------筛选组件构造对象 --------------------------*/
/*
  type : 用来确定 使用哪个组件
  name ：组件显示的头部文字
  children: 子列表数据
  that: 当前页面对象
*/
function FilterItem({ type, name, children, selectedIndex }) {
  console.log("[fn] FilterItem excuted");

  /* 如果是来源 获取图片路径 */
  // 社工页 来源类型 'sgzs','dyrh','csbd', 'sqyzs'
  this._getIconPath = function(type, obj) {
    
    if (type == "source") {
      switch (obj.type) {
        case "gzh":
          return require("../../assets/images/filter/gzh.png");
        case "xfej":
          return require("../../assets/images/filter/xfej.png");
        case "mst":
          return require("../../assets/images/filter/mst.png");
        default:
          return "";
      }
    } else {
      return "";
    }
  };
  /* 是否可编辑 以后扩展*/
  this.editMode = function(type) {
    switch (type) {
      case "organization":
        return true;
      default:
        return false;
    }
  };
  /* 初始化 组件类型 this.name 确定组件类型 保证名称一致*/
  switch (type) {
    case "organization":
      this.name = "sort";
      break;
    case "party":
      this.name = "microorg";
      break;
    case "source":
      this.name = "origin";
      break;
    case "zone":
      this.name = "community";
      break;
    case "community":
      this.name = "singleDivision";
      break;
  }
  /* 对象类型 */
  this.type = type;
  /* 初始化对象 数据 */
  this.data = {
    title: name, // 解构过来的name
    edit: this.editMode(type),
    dataList: children.map((item, index) => {
      return {
        id: item.id,
        label: item.name,
        number: item.userCount,
        iconPath: this._getIconPath(type, item),
        type: item.type || ""
      };
    })
  };
  if (selectedIndex > -1) {
    console.log(111);
    this.data.selectedIndex = selectedIndex;
  }
  /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
  this.event = function(e) {
    that[e.fn](e);
  };
}
</script>

<style lang="less" scoped>
/* 头部信息 开始 */
.wrapper {
  color: #666666;
  min-height: 100.1%; // 强制滚动
  // margin-right: -17px;
}
/* 头部信息 结束 */
// 分页组件
.fenye {
  // width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 150px;
  right: 255px;
  height: 40px;
  box-shadow: 0px -5px rgba(225, 225, 225, 0.5);
  // left: 40%
}
.page {
  margin-left: 50px;
}
.clickAll {
  margin-left: 20px;
  line-height: 40px;
}
.clickTotal {
  line-height: 40px;
}
.clickBtn {
  margin-left: 80px;
  line-height: 40px;
  button {
    height: 30px;
    margin-right: 10px;
    line-height: 15px;
  }
}
/* 移动对话框 */
.add-wrapper {
  min-height: 360px;
}
.add-item {
  display: flex;
  align-items: center;
}
.add-label {
  min-width: 4em;
  white-space: nowrap;
  text-align: right;
  font-size: 18px;
  color: #666;
  margin: 15px 10px 15px 0;
}
.add-input {
  flex: 1;
}
.icon-duoxuan1 {
  color: #d22c2b;
}
.code-content {
  height: 260px;
  .code-img {
    margin: 86px auto 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 172px;
    height: 172px;
    border: 1px solid #ddd;
  }
  img {
    width: 155px;
    height: 155px;
  }
  .code-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fe9163;
    text-decoration: underline;
  }
}
.tr {
  line-height: 36px;
  .tr_title {
    margin-right: 20px;
    width: 60px;
  }
}
/* 社工加入 */
.searchcard-wrapper {
  padding-top: 30px;
  height: 300px;
  overflow-y: scroll;

  display: flex;
  flex-wrap: wrap;
}
.nodata {
  margin: 0 auto;
  padding-top: 40px;
}
.search-card {
  width: 120px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  cursor: pointer;
  position: relative;
}
.searchcard-wrapper::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ccc;
}
.search-name {
  text-align: center;
  color: #4b4b4b;
  font-weight: 600;
}
.search-username {
  text-align: center;
  color: #999;
}
.select {
  border: 1px solid #ff7b44;
}
.xuanzhong-icon {
  position: absolute;
  top: -12px;
  right: -14px;
  height: 25px;
  width: 25px;
}
.avatar-wrap {
  padding: 30px 0 20px 35px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
